<template>
  <div class="jobs" v-if="list.length > 0">
    <van-row v-for="(item, index) in list" :key="index" class="job-group" @click="showDetail(item)">
      <van-col span="18" class="tl">
        <div class="title">{{item.job_name}}</div>
        <div class="tag-list">
          <tag>{{item.city_name}}</tag>
          <tag>{{item.degree_require}}</tag>
        </div>
        <div class="clearfix bottom">
          <van-image width="0.18rem" height="0.18rem" :src="companyInfo.logo_url" class="fl" />
          <span class="fl item-name" style="margin-left: 0.05rem;">{{companyInfo.company_name}}</span>
        </div>
      </van-col>
      <van-col span="6">
        <div class="title light">{{item.salary}}</div>
        <div class="create-time">{{item.create_time}}</div>
      </van-col>
    </van-row>

    <action-sheet v-model="show" title="职位详情">
      <div class="detail-card">
        <wy-card>
          <div class="detail-card-header">
            <div class="item-content has-other">
              <div class="item-left">
                <p class="item-title">{{currentItem.job_name}}</p>

                <p class="item-tip">
                  <span v-if="!!currentItem.city_name">{{currentItem.city_name}}</span>
                  <span v-if="!!currentItem.degree_require">{{currentItem.degree_require}}</span>
                  <span v-else>不限</span>
                  <span v-if="!!currentItem.scale">规模{{currentItem.scale}}</span>
                </p>

                <p class="tag-list" v-if="currentItem.keywords">
                  <span
                    class="tag-item"
                    v-for="(key, index) in currentItem.keywords.replace(/\s+/g, ' ').split(' ')"
                    :key="index"
                  >
                    <span v-if="key">{{key}}</span>
                  </span>
                </p>
              </div>
              <div class="item-right">
                <p
                  class="item-time front-theme"
                  v-if="currentItem.salary"
                >{{ (currentItem.salary != '0') ? currentItem.salary.replace('/月', '') :'面议' }}</p>
              </div>
            </div>
          </div>
          <div class="detail-card-content">
            <section>
              <p class="section-title">岗位要求：</p>
              <div class="section-content" v-html="currentItem.job_descript"></div>
            </section>
            <section>
              <p class="section-title">岗位职责：</p>
              <div class="section-content" v-html="currentItem.job_descript"></div>
            </section>
            <section>
              <p class="section-title">其它描述：</p>
              <div class="section-content" v-html="currentItem.job_descript"></div>
            </section>
          </div>
        </wy-card>
      </div>
    </action-sheet>
  </div>
  <no-data v-else></no-data>
</template>

<script>
import NoData from "@/components/NoData";
import WyCard from "@/components/WyCard";

import { Tag, ActionSheet } from "vant";

export default {
  name: "jobs",
  components: {
    Tag,
    ActionSheet,
    WyCard,
    NoData
  },
  props: {
    list: {
      typeof: Array
    },
    companyInfo: {
      typeof: Object
    }
  },
  data() {
    return {
      show: false,
      currentItem: {}
    };
  },
  mounted() {},
  methods: {
    showDetail(item) {
      const { publish_id } = item;

      let that = this

      that.$util
        .goToWxProgram(
          "/pages/seeker/jobs/detail/main?publish_id=" + publish_id,
          "navigateTo"
        )
        .then((state) => {
          if (state === "fail") {
            that.getDetail(publish_id);
          }
        });
    },
    getDetail(publish_id) {
      let that = this;

      return new Promise(resolve => {
        that.$util
          .get("kzp_video_jobfair", "job_detail", {
            publish_id
          })
          .then(res => {
            const { code, msg, data } = res;

            if (code === 1) {
              that.$set(that, "currentItem", data);
              that.show = true;
            } else {
              that.$notify({
                message: msg || "获取数据失败，请稍后再试！",
                type: "danger"
              });
            }

            resolve();
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jobs {
  .van-action-sheet {
    // min-height: 70%;
  }
}
.job-group {
  $mainC: #3a3a3a;
  $grayC: #999;
  $lightC: #378ede;
  $grayC1: #f3f3f3;
  padding: 0.1rem 0;

  color: $mainC;
  border-bottom: 1px solid $grayC1;

  .title {
    font-size: 0.14rem;
    line-height: 0.2rem;
  }

  .light {
    color: $lightC;
  }

  .tag-list {
    padding: 0.05rem 0;

    .van-tag {
      margin-right: 0.07rem;
      background-color: $grayC1;
      color: $grayC;
      padding: 0.02rem;
      line-height: 0.14rem;
    }
  }

  .bottom {
    padding: 0.04rem 0 0.05rem;

    .item-name {
      line-height: 0.18rem;
      font-size: 0.12rem;
    }
  }

  .create-time {
    padding-top: 0.32rem;
    line-height: 0.18rem;
    font-size: 0.12rem;
  }
}

.detail-card {
  background: #f3f3f3;
  text-align: left;
  padding: 0.15rem;

  .detail-card-header {
    @include list-item(0px);
    margin-bottom: 0px;
    padding: 0;
    border-radius: 0;

    .iconfont {
      margin-left: 5px;
      font-size: 0.2rem;
      color: #666666;
    }

    .tag-list {
      margin-top: 0.05rem;

      .tag-item {
        margin-right: 5px;
        margin-bottom: 3px;
      }
    }

    .item-tip {
      margin-top: 0.05rem;
      color: #999999;
      line-height: 0.14rem;
    }

    .item-right {
      .item-time {
        position: absolute;
        top: 0.43rem;
        right: 0;
      }
    }
  }

  .detail-card-content {
    line-height: 17px;

    .section-title {
      margin: 10px 0;
      font-weight: Bold;
    }

    .section-content {
      font-size: 0.12rem;
      color: #666666;
    }
  }
}
</style>
